import React from "react";

interface LoadingSkeletonProps {
    title?: string;
    showTitle?: boolean;
    lines?: number;
    className?: string;
}

export default function LoadingSkeleton({ 
    title, 
    showTitle = true, 
    lines = 3, 
    className = "" 
}: LoadingSkeletonProps) {
    return (
        <div className={`bg-white shadow rounded-lg p-6 ${className}`}>
            {showTitle && title && (
                <div className="flex items-center gap-2 mb-4">
                    <h2 className="text-lg font-semibold">{title}</h2>
                </div>
            )}
            
            <div className="space-y-3">
                {Array.from({ length: lines }).map((_, index) => (
                    <div key={index} className="flex items-center space-x-3">
                        <div className="w-20 h-4 bg-gray-200 rounded animate-pulse"></div>
                        <div className="flex-1 h-4 bg-gray-200 rounded animate-pulse"></div>
                    </div>
                ))}
            </div>
        </div>
    );
} 